import { Tooltip } from "@mui/material";
import { MdEdit } from "react-icons/md";
import { Fragment, useState } from "react";
import { Button, IconButton, Typography } from "@mui/material";

import "../../details components/nodes.css";
import FilterUser from "../filter user components/Filter";

export default function ConditionSelection({ formikProps }) {
  console.log(
    formikProps.values.filters[0],
    "hhjh",
    Object.keys(formikProps.values.filters[0]).every((key) => console.log(key))
  );
  const [editCondition, setEditCondition] = useState(
    Object.keys(formikProps.values.filters[0]).every(
      (key) => formikProps.values.filters[0][key]
    )
      ? false
      : true
  );

  return (
    <Fragment>
      {formikProps.values.stage >= 2 && (
        <div className="filter-outer-div">
          <div>
            <div className="condition-div">
              <div className="diamond">
                <Typography className="condition-typo" variant="h4">
                  CONDITION
                </Typography>
                <Typography
                  style={{ left: "-8px" }}
                  className="condition-typo"
                  variant="h4"
                >
                  1
                </Typography>
              </div>
            </div>
          </div>

          <div className="diamond-icon">
            <div className="diamond-arrow"></div>
          </div>

          <div
            className="filter-div"
            style={{
              marginTop: "25px",
              width: "700px",
            }}
          >
            <Fragment>
              <div
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                  display: "flex",
                }}
              >
                <Typography variant="h5">
                  Which deals would you like to apply the rule to?
                </Typography>

                {!editCondition && (
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={() => setEditCondition(!editCondition)}
                      style={{ padding: "2px" }}
                    >
                      <MdEdit />
                    </IconButton>
                  </Tooltip>
                )}
              </div>

              <div style={{ width: "100%" }}>
                <FilterUser
                  editCondition={!editCondition}
                  filter={true}
                  formikProps={formikProps}
                />

                {editCondition && (
                  <Button
                    onClick={() => {
                      setEditCondition(false);
                      formikProps.setValues((prev) => ({
                        ...prev,
                        stage: 3,
                      }));
                    }}
                    variant="contained"
                    style={{ float: "right", marginTop: "30px" }}
                  >
                    Save Flow
                  </Button>
                )}
              </div>
            </Fragment>
          </div>
        </div>
      )}
    </Fragment>
  );
}

//  {editCondition ? (
//   <Fragment>
//     <div style={{ width: "100%", marginBottom: "10px" }}>
//       <Typography variant="h5">
//         Which deals would you like to apply the rule to?
//       </Typography>
//     </div>

//     <div style={{ width: "100%" }}>
//       <FilterUser filter={true} formikProps={formikProps} />

//       <Button
//         onClick={() => {
//           // setEditCondition(false);
//           formikProps.setValues((prev) => ({
//             ...prev,
//             stage: 3,
//           }));
//         }}
//         variant="contained"
//         style={{ float: "right", marginTop: "30px" }}
//       >
//         Save Flow
//       </Button>
//     </div>
//   </Fragment>
// ) : (
//   <div className="when-edit-false">
//     <div style={{ textAlign: "end" }}>
//       <Tooltip title="Edit">
//         <IconButton
//           onClick={() => setEditCondition(!editCondition)}
//           style={{ padding: "2px" }}
//         >
//           <MdEdit />
//         </IconButton>
//       </Tooltip>
//     </div>

//     {formikProps.values.filters.map((cond, index) => (
//       <div>
//         <Typography variant="h6">
//           {index +
//             1 +
//             ". " +
//             cond.key +
//             " " +
//             (cond.operator === "eq" ? "equals to" : cond.operator) +
//             " " +
//             cond.value}
//         </Typography>

//         {cond.relation && (
//           <Typography color="#555453" variant="subtitle1">
//             Criteria is {cond.relation}
//           </Typography>
//         )}
//       </div>
//     ))}
//   </div>
// )}
